import * as ActionTypes from './StylingFirmsActionTypes';
import { IStylingFirm, IProduct } from '../Entities';
import StylingFirmApi from '../api/StylingFirmsApi';

function getStylingFirmsSuccess(StylingFirms: IStylingFirm[]) {
    return {
        type: ActionTypes.GET_STYLING_FIRMS_SUCCESS,
        result: StylingFirms
    };
}

export function getStylingFirms() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.getStylingFirms().then((result: IStylingFirm[]) => {
            dispatch(getStylingFirmsSuccess(result));
        });
}

function saveStylingFirmSuccess(StylingFirm: IStylingFirm) {
    return { type: ActionTypes.SAVE_STYLING_FIRM_SUCCESS, result: StylingFirm };
}

export function addStylingFirm(StylingFirm: IStylingFirm) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.saveStylingFirm(StylingFirm).then((result: IStylingFirm) => {
            dispatch(saveStylingFirmSuccess(result));
        });
}

function getStylingFirmSuccess(StylingFirm: IStylingFirm) {
    return { type: ActionTypes.GET_STYLING_FIRM_SUCCESS, result: StylingFirm };
}

export function getStylingFirm(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.getStylingFirm(id).then((result: IStylingFirm) => {
            dispatch(getStylingFirmSuccess(result));
        });
}

function updateStylingFirmSuccess(StylingFirm: IStylingFirm) {
    return {
        type: ActionTypes.UPDATE_STYLING_FIRM_FORM_SUCCESS,
        result: StylingFirm
    };
}

export function updateStylingFirm(StylingFirm: IStylingFirm) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.updateStylingFirm(StylingFirm).then(() => {
            dispatch(updateStylingFirmSuccess(StylingFirm));
        });
}

function getStylingFirmProductsSuccess(result: IProduct[]) {
    return {
        type: ActionTypes.GET_STYLING_FIRM_PRODUCTS_SUCCESS,
        result: result
    };
}

export function getStylingFirmProducts() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.getStylingFirmProducts().then((result: IProduct[]) => {
            dispatch(getStylingFirmProductsSuccess(result));
        });
}

function deleteStylingFirmSuccess(result: IStylingFirm) {
    return { type: ActionTypes.DELETE_STYLING_FIRM_SUCCESS, result: result };
}

export function deleteStylingFirm(stylingFirm: IStylingFirm) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.deleteStylingFirm(stylingFirm).then(() => {
            dispatch(deleteStylingFirmSuccess(stylingFirm));
        });
}
